import React from 'react';
import classnames from 'classnames';

const block = 'airtame-info-message-actions';

export type InfoMessageActionsProps = React.HTMLAttributes<HTMLDivElement>;

export const InfoMessageActions = ({
  children,
  className,
  ...props
}: InfoMessageActionsProps): React.ReactElement => {
  const classNames = classnames(className, block);

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};
